import type { Theme } from '@mui/material'

export const APP_SCROLLABLE_WRAPPER_ID = 'app-scrollable-wrapper'
export const mainWrapperContainerName = 'main-content'

// Set by a surface pages sit on (the app shell's page area, a grey side panel) so what blends into it can follow.
export const PAGE_SURFACE_VAR = '--page-surface'

/** The colour of the surface the page sits on, for fades and bars that blend into it; the classic page grey by default. */
export const pageSurface = (theme: Theme) => `var(${PAGE_SURFACE_VAR}, ${theme.palette.bg.surface.subtle})`
